import { createFileRoute } from "@tanstack/react-router";
import { AdminFinancialsPage } from "@/components/admin/pages/AdminFinancialsPage";

export const Route = createFileRoute("/pulse-ops-x7k2/financials")({
  component: AdminFinancialsPage,
});
